import { jsx } from "react/jsx-runtime";
import { Component, Suspense } from "react";
import { AppButtonClassesContext } from "@nxplatform/helpers/custom-classes-context";
import { lazyImport } from "@nxplatform/helpers/helpers";
const { ErrorBoundaryComponent } = lazyImport(() => import("./error-boundary.component.js"), "ErrorBoundaryComponent");
const _ErrorBoundary = class _ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    this.state = { hasError: false, error: null, errorInfo: null };
    this.context = null;
  }
  static getDerivedStateFromError(error) {
    document.body.classList.add("error-boundary");
    return { hasError: true };
  }
  static getDerivedStateFromProps(props, state) {
    if (!state.hasError) {
      document.body.classList.remove("error-boundary");
    }
    return null;
  }
  componentDidMount() {
    this.appButtonClasses = this.context;
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }
  render() {
    const { hasError } = this.state;
    if (hasError) {
      return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(ErrorBoundaryComponent, { buttonClasses: this.appButtonClasses }) });
    }
    return this.props.children;
  }
};
_ErrorBoundary.contextType = AppButtonClassesContext;
let ErrorBoundary = _ErrorBoundary;
export {
  ErrorBoundary
};
